import { Component, inject } from '@angular/core';

import { AuthFacade } from '@mitsubishi/core';

import { FieldWrapper } from '@ngx-formly/core';

@Component({
  selector: 'apm-gallery-wrapper',
  templateUrl: './gallery-wrapper.component.html',
  styleUrls: ['./gallery-wrapper.component.scss'],
  standalone: false,
})
export class GalleryWrapperComponent extends FieldWrapper {
  canDebug = inject(AuthFacade).canDebug;
}
